"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMenuSections = void 0;
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const MORE_OPTIONS_KEYS_GP = [
    'support',
    'search',
    'login',
    'shop',
    'profile',
    'notifications',
];
/* EMP CONFIGURATION */
const MORE_OPTIONS_KEY_EMP = ['login', 'search', 'profile'];
const NOT_ALLOWED_ITEMS_FOR_ACTIONBAR_EMP = ['search', 'profile', 'shop'];
/* GP CONFIGURATION */
const NOT_ALLOWED_ITEMS_FOR_ACTIONBAR_GP = ['search', 'shop'];
/**
 * Obitiene la configuracion correspondiente para cada una de las secciones cuando se visualiza,
 * la visualización para gestor
 * @param {object} allMenuOptions todas las opciones del menu
 * @param {object} forcedTitleBarId (opcional) id del titlebar a forzar
 * @param {object} forcedTitleBarIdLink (opcional) link del titlebar forzar
 * @param {string} actionBarIdSelected envía el id de actionbar seleccionado (mobile)
 * @param {string} handleSeveral funcion para sondar heredada
 * @return {object} { menu, options, actionBar }
 */
/**
 * Obtiene la configuracion correspondiente para cada una de las secciones con visualizacion normal
 * @param {object} allMenuOptions todas las opciones del menu
 * @param {String} userType tipo de usuario (telco, legado, no logado...)
 * @param {String} segment segmento
 * @param {String} actionBarIdSelected id del action bar seleccionado
 * @return {object} { menu, options, actionBar }
 */
const getMenuSections = (allMenuOptions, userType, segment, actionBarIdSelected, userSegment) => {
    const menu = [];
    const options = [];
    const actionBar = [];
    let realSegment = segment;
    if (userSegment) {
        realSegment = (0, utils_1.decideUserSegment)(userSegment, segment);
    }
    /* Creating <MENU /> <OPTIONS /> depends on realsegment */
    // page particulaers => user particulares
    if (allMenuOptions && realSegment === constants_1.PARTICULARES) {
        const menuKeys = Object.keys(allMenuOptions);
        menuKeys.forEach((menuKey) => {
            const menuItem = allMenuOptions[menuKey];
            /* pc => <Menu> and <MoreOptions> */
            if (!MORE_OPTIONS_KEYS_GP.includes(menuKey) ||
                (userType && menuKey === 'support')) {
                menu.push(Object.assign(Object.assign({}, menuItem), { selected: menuKey === actionBarIdSelected, titleBarId: menuKey }));
            }
            else {
                options.push(Object.assign(Object.assign({}, menuItem), { titleBarId: menuKey }));
            }
            // <ActionBAr />
            if (!NOT_ALLOWED_ITEMS_FOR_ACTIONBAR_GP.includes(menuKey)) {
                actionBar.push(Object.assign(Object.assign({}, menuItem), { selected: menuKey === actionBarIdSelected, titleBarId: menuKey }));
            }
        });
    }
    if (allMenuOptions && realSegment === constants_1.EMPRESAS) {
        const menuKeys = Object.keys(allMenuOptions);
        menuKeys.forEach((menuKey) => {
            const menuItem = allMenuOptions[menuKey];
            if (MORE_OPTIONS_KEY_EMP.includes(menuKey)) {
                options.push(Object.assign(Object.assign({}, menuItem), { titleBarId: menuKey }));
            }
            else {
                menu.push(Object.assign(Object.assign({}, menuItem), { titleBarId: menuKey, selected: menuKey === actionBarIdSelected }));
            }
            if (!NOT_ALLOWED_ITEMS_FOR_ACTIONBAR_EMP.includes(menuKey)) {
                actionBar.push(Object.assign(Object.assign({}, menuItem), { selected: menuKey === actionBarIdSelected, titleBarId: menuKey }));
            }
        });
    }
    return { menu, options, actionBar };
};
exports.getMenuSections = getMenuSections;
//# sourceMappingURL=movistarMenuNormalizers.js.map